// extracted by mini-css-extract-plugin
export default {"App":"Layout_App__C0sYI","main":"Layout_main__gReih"};